/* A live cohort's home in any look but The Funding Engine's (the product-types plan, 13 Oct). A new
   live cohort takes The Funding Engine's home (src/product/screens.js), which funding-engine.css draws
   with The Funding Engine's tokens. Inside the Accelerator family's, Profit On Your Terms family's or
   the master brand's frame (product.css: .pp--acc, .pp--poyt, .pp--master, which an own look's frame
   is too), those tokens point at the frame's own, so the product's own look fills the page and the
   looks never mix:
   - the page, the cards, the text and the soft text are the frame's;
   - buttons and small marks take the look's button colour (Profit On Your Terms' navy, never its
     orange, so white on them passes the contrast check), and a tint of the look where The Funding
     Engine has its green at 22%;
   - "Carry on" and the like take the look's own colour for when (gold never carries text in the
     master brand);
   - the rules and the faint fills are the look's;
   - headings in the look's heading font and weight, in sentence case, at the family's own sizes
     (poyt.css's and accelerator.css's home headings; the master brand's as the shell sets them).
   The Funding Engine's own frame (.pp--fe) is never named here, so its home is exactly as before, and
   Profit On Your Terms's home never draws .fe-home (it has its own screens, by its slug). */

.pp--master .fe-home, .pp--acc .fe-home, .pp--poyt .fe-home {
  --fe-bg: var(--pp-bg);
  --fe-surface: var(--pp-card);
  --fe-text: var(--pp-ink);
  --fe-muted: var(--pp-soft);
  --fe-green: var(--pp-btn-bg);
  --fe-on-green: var(--pp-btn-fg);
  --fe-green-22: var(--pp-tint);
  --fe-gold: var(--pp-when);
  --fe-heading-font: var(--pp-head-font);
  --fe-body-font: var(--pp-body-font);
  --on-dark-04: var(--pp-tint);
  --on-dark-08: var(--pp-rule-soft);
  --on-dark-12: var(--pp-rule);
  --on-dark-28: var(--pp-round-line);
  font-family: var(--pp-body-font);
  color: var(--pp-ink);
}

/* Sentence case, in the look's own heading weight */
.pp--master .fe-home :is(.fe-h2, .fe-h3, .fe-hero-h1, .fe-lead-title, .fe-wk-label),
.pp--acc .fe-home :is(.fe-h2, .fe-h3, .fe-hero-h1, .fe-lead-title, .fe-wk-label),
.pp--poyt .fe-home :is(.fe-h2, .fe-h3, .fe-hero-h1, .fe-lead-title, .fe-wk-label) {
  text-transform: none; font-weight: var(--pp-heading-weight); letter-spacing: -0.01em;
}
/* the eyebrow keeps its small capitals, as every look's eyebrows have them */

/* Profit On Your Terms family: poyt.css's home headings (.py-h2, .py-h3, the hero at 48px) */
.pp--poyt .fe-home .fe-h2 { font-size: 26px; }
.pp--poyt .fe-home .fe-h3 { font-size: 19px; }
.pp--poyt .fe-home .fe-hero-h1, .pp--poyt .fe-home .fe-lead--main .fe-lead-title { font-size: 48px; line-height: 1.08; }
.pp--poyt .fe-home .fe-lead-title { font-size: 24px; line-height: 1.2; }
.pp--poyt .fe-home .fe-wk-label { font-size: 15px; }

/* The Accelerator family: accelerator.css's home headings (.acc-h2, .acc-h3, the next session's 30px) */
.pp--acc .fe-home .fe-h2 { font-size: 21px; }
.pp--acc .fe-home .fe-h3 { font-size: 17px; }
.pp--acc .fe-home .fe-hero-h1, .pp--acc .fe-home .fe-lead--main .fe-lead-title { font-size: 44px; line-height: 1.1; }
.pp--acc .fe-home .fe-lead-title { font-size: 22px; line-height: 1.25; }
.pp--acc .fe-home .fe-wk-label { font-size: 15px; }

/* The master brand: Manrope at 800, the Library's own sizes */
.pp--master .fe-home .fe-h2 { font-size: 24px; }
.pp--master .fe-home .fe-h3 { font-size: 19px; }
.pp--master .fe-home .fe-hero-h1, .pp--master .fe-home .fe-lead--main .fe-lead-title { font-size: 48px; line-height: 1.08; }
.pp--master .fe-home .fe-lead-title { font-size: 24px; line-height: 1.2; }
.pp--master .fe-home .fe-wk-label { font-size: 16px; }

/* Between a laptop and a phone, and a phone, as funding-engine.css steps down */
@media (max-width: 1099px) {
  .pp--master .fe-home .fe-hero-h1, .pp--acc .fe-home .fe-hero-h1, .pp--poyt .fe-home .fe-hero-h1,
  .pp--master .fe-home .fe-lead--main .fe-lead-title, .pp--acc .fe-home .fe-lead--main .fe-lead-title,
  .pp--poyt .fe-home .fe-lead--main .fe-lead-title { font-size: 40px; }
}
@media (max-width: 760px) {
  .pp--master .fe-home .fe-hero-h1, .pp--acc .fe-home .fe-hero-h1, .pp--poyt .fe-home .fe-hero-h1,
  .pp--master .fe-home .fe-lead--main .fe-lead-title, .pp--acc .fe-home .fe-lead--main .fe-lead-title,
  .pp--poyt .fe-home .fe-lead--main .fe-lead-title { font-size: 32px; line-height: 1.1; }
  .pp--master .fe-home .fe-lead-title, .pp--acc .fe-home .fe-lead-title, .pp--poyt .fe-home .fe-lead-title { font-size: 21px; }
  .pp--master .fe-home .fe-h2, .pp--acc .fe-home .fe-h2, .pp--poyt .fe-home .fe-h2 { font-size: 21px; }
  .pp--master .fe-home .fe-h3, .pp--acc .fe-home .fe-h3, .pp--poyt .fe-home .fe-h3 { font-size: 17px; }
  .pp--master .fe-home .fe-wk-label, .pp--acc .fe-home .fe-wk-label, .pp--poyt .fe-home .fe-wk-label { font-size: 15px; }
}
